<template>
  <div class="history-img">
    <section id="timeline">
      <div v-for="(item, index) in history" :key="index" class="t1-item">
        <div class="t1-bg" :style="{ backgroundImage: `url(${require(`@/assets/companyprofilepic/${item.img}`)})` }"></div>
        <div class="t1-year">
          <p class="f2 heading">{{item.time}}</p>
        </div>
        <div class="t1-content">
          <h1>{{ item.title }}</h1>
          <p>{{ $t(`history.${item.text}`) }}</p>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "History",
  data() {
    return {
      history: [
        { img: '2017.jpg', time: '2017',text: '1'},
        { img: '2018.jpg', time: '2018',text: '2'},
        { img: '2019.jpg', time: '2019',text: '3'},
        { img: '2021.7.15.jpg', time: '2021.7.15',text: '4'},
        { img: '2021.12-2022.11.jpg', time: '2022.11',text: '5'},
        { img: '2022.12.jpg', time: '2022.12',text: '6'},
        { img: '2023.3.jpg', time: '2023.3',text: '7'},
        { img: '2023.11.jpg', time: '2023.11',text: '8'},
      ]
    };
  },
}
</script>

<style scoped>
.history-img {
  /* font-family: tahoma; */
  font-size: 15px;
  line-height: 1.75;
  padding: 0;
  margin: 0;
  margin-bottom: 50px;
}

#timeline {
  display: flex;
  background-color: #fff;
}

#timeline:hover .t1-item {
  width: 23.3333%;
}

.t1-item {
  transform: translate3d(0,0,0);
  position: relative;
  width: 25%;
  height: 65vh;
  min-height: 400px;
  color: white;
  overflow: hidden;
  transition: width 0.5s ease;
}

.t1-item::before, .t1-item::after {
  transform: translate3d(0,0,0);
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
}

.t1-item::after {
  background: rgba(1, 143, 215, 0.65);
  opacity: 1;
  transition: opacity .5s ease;
}

.t1-item::before {
  background: linear-gradient(to bottom, rgba(0,0,0,0) 0%, rgba(0,0,0,1) 90%);
  z-index: 1;
  opacity: 0;
  transform: translate3d(0,0,0) translateY(50%);
  transition: opacity .5% ease, transform .5s ease;
}

.t1-item:hover {
  width: 30% !important;
}

.t1-item:hover::after {
  opacity: 0;
}

.t1-item:hover::before {
  opacity: 1;
  transform: translate3d(0,0,0) translateY(0);
  transition: opacity 1s ease, transform 1s ease .25s;
}

.t1-item:hover .t1-content {
  opacity: 1;
  transform: translateY(0);
  transition: all .75s ease .5s;
}

.t1-item:hover .t1-bg {
  filter: grayscale(0);
}

.t1-content {
  transform: translate3d(0,0,0) translateY(25px);
  position: relative;
  z-index: 1;
  text-align: center;
  margin: .1618em;
  top: 40%;
  opacity: 0;
}

.t1-content h1 {
  /* font-family: tahoma; */
  text-transform: uppercase;
  color: #018fd7;
  font-size: 1.44rem;
  font-weight: normal;
}

.t1-content p {
  padding: 0 1em 0 1em;
}

.t1-year {
  position: absolute;
  top: 30%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
  z-index: 1;
  border-top: 1px solid white;
  border-bottom: 1px solid white;
}

.t1-year p {
  /* font-family: tahoma; */
  font-size: 1.628rem;
  line-height: 0;
}

.t1-bg {
  transform: translate3d(0,0,0);
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-size: cover;
  background-position: center center;
  transition: filter .5s ease;
  filter: grayscale(100%);
}

@media (max-width: 768px) {
  #timeline {
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  gap: 30px;
  margin: 30px 15vw;
}

.t1-content p {
  font-size: 1.7vw;
}
.t1-year p {
  font-size: 4vw;
}

.t1-item {
  width: 90%;
}

.t1-item:hover {
  width: 100% !important;
}

#timeline:hover .t1-item {
  width: 90%;
}
}
</style>


// WEBPACK FOOTER //
// src/views/home/products/History.vue